import { throttle } from 'lodash-es';

// 取消冒泡
const stopBubbling = (element) => {
  element.onmousedown = (e) => {
    const event = e || window.event;
    event.stopPropagation(); // 取消冒泡
  };
};

// 点击后的函数
const mouseDown = (e, value, el) => {
  const event = e || window.event;
  event.preventDefault(); // 通知 Web 浏览器不要执行与事件关联的默认动作
  event.stopPropagation(); // 取消冒泡
  const mouseBoxLeft = event.pageX - el.offsetLeft; // 鼠标到盒子左边距离
  const mouseBoxTop = event.pageY - el.offsetTop;
  const docW = document.body.offsetWidth; // 屏幕宽
  const docH = document.body.offsetHeight;
  if (!value.disabled) {
    el.classList.add('drag-move-style');
    let left;
    let top;
    let notFixed = true;
    const elStyle = el.style;
    document.onmousemove = throttle((e) => {
      if (notFixed) {
        elStyle.position = 'fixed';// 写在里面是为了防止首次点击盒子抖动
        elStyle.margin = 'auto';// 去掉margin
        notFixed = false;
      }
      const moveEvent = e || window.event;
      // 左右边界判断
      if (moveEvent.pageX - mouseBoxLeft < 0 && !value.beyond) {
        left = 0;
      } else if (moveEvent.pageX - mouseBoxLeft + el.offsetWidth > docW && !value.beyond) {
        left = docW - el.offsetWidth;
      } else {
        left = moveEvent.pageX - mouseBoxLeft;
      }
      // 上下边界判断
      if (value.isPC && moveEvent.pageY - mouseBoxTop < 60) {
        top = 60;
      } else if (moveEvent.pageY - mouseBoxTop < 0 && !value.beyond) {
        top = 0;
      } else if (moveEvent.pageY - mouseBoxTop + el.offsetHeight > docH && !value.beyond) {
        top = docH - el.offsetHeight;
      } else {
        top = moveEvent.pageY - mouseBoxTop;
      }
      elStyle.left = `${left}px`;
      elStyle.top = `${top}px`;
      // el.setAttribute('style',`left:${left}px;top:${top}px`); //这里不能用，可能是权级不够
    }, 30);
  }
  document.onmouseup = () => {
    el.classList.remove('drag-move-style');
    document.onmousemove = null;
    document.onmouseup = null;
  };
};

// 子带父移动点击时
const childMoveFatherMouseDown = (element, checkedNodes, value, el) => {
  element.onmousedown = (e) => {
    const event = e || window.event;
    if (checkedNodes.length === 0) {
      mouseDown(event, value, el);
    } else if (checkedNodes.length > 0) {
      checkedNodes.forEach((checkedNode) => {
        mouseDown(event, value, checkedNode);
      });
    } else {
      mouseDown(event, value, checkedNodes);
    }
  };
};

// 限制拖拽
const stopDragBox = (value, el) => {
  // 拖拽块内不可拖拽子元素
  const invalidIdChilds = value.invalidChildId
    ? value.invalidChildId.trim().split(/\s+/)
    : [];
  const invalidClassChilds = value.invalidChildClass
    ? value.invalidChildClass.trim().split(/\s+/)
    : [];
  if (invalidIdChilds.length !== 0) {
    invalidIdChilds.forEach((invalidIdChild) => {
      const element = el.querySelector(`#${invalidIdChild}`);
      if (element) {
        stopBubbling(element);
      }
    });
  }
  if (invalidClassChilds.length !== 0) {
    invalidClassChilds.forEach((invalidClassChild) => {
      const elements = el.querySelectorAll(`.${invalidClassChild}`);
      elements.forEach((element) => {
        stopBubbling(element);
      });
    });
  }
};

// 子元素带动父元素相对浏览器移动
const childMoveFather = (checkedNodes, value, el) => {
  const dragIdChilds = value.dragChildId
    ? value.dragChildId.trim().split(/\s+/)
    : [];
  const dragClassChilds = value.dragChildClass
    ? value.dragChildClass.trim().split(/\s+/)
    : [];
  let hasChildBox = false;
  if (dragIdChilds.length !== 0) {
    dragIdChilds.forEach((dragIdChild) => {
      const element = el.querySelector(`#${dragIdChild}`);
      if (element) {
        hasChildBox = true;
        childMoveFatherMouseDown(element, checkedNodes, value, el);
      }
    });
  }
  if (dragClassChilds.length !== 0) {
    dragClassChilds.forEach((dragClassChild) => {
      const elements = el.querySelectorAll(`.${dragClassChild}`);
      elements.forEach((element) => {
        hasChildBox = true;
        childMoveFatherMouseDown(element, checkedNodes, value, el);
      });
    });
  }
  return hasChildBox;
};

export default function (el, binding) {
  // {}兼容什么值也不传
  const { value = {} } = binding;

  stopDragBox(value, el);

  // 限制拖拽/移动(当前移动元素)
  const checkedNodes = el.querySelector(`#${value.moveId}`)
    || el.querySelectorAll(`.${value.moveClass}`);

  if (childMoveFather(checkedNodes, value, el)) {
    return;
  }
  // 移动元素判断id len -> undefined,class len -> 大于0,没有 ->[]
  if (checkedNodes.length === 0) {
    el.onmousedown = (e) => {
      const event = e || window.event;
      mouseDown(event, value, el);
    };
  } else if (checkedNodes.length > 0) {
    checkedNodes.forEach((element) => {
      element.onmousedown = (e) => {
        const event = e || window.event;
        mouseDown(event, value, el);
      };
    });
  } else {
    checkedNodes.onmousedown = (e) => {
      const event = e || window.event;
      mouseDown(event, value, el);
    };
  }
}



// WEBPACK FOOTER //
// ./src/directive/directiveOtherFn/drag.js